'use client';

import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { HiChevronRight } from 'react-icons/hi';

import { dashboardUrl } from '@/src/utils/processenv';
import {
  goToPartnerPage,
  sendAnalyticsData,
  trackGetStartedClicked,
  trackNavigation,
} from '../utils/analytics';

export const StartTrialInput = () => {
  const signupUrl = `${dashboardUrl}/signup`;
  const { t } = useTranslation();

  return (
    <>
      <div className="flex flex-col items-center gap-3 md:flex-row">
        <a
          href={signupUrl}
          onClick={() => {
            sendAnalyticsData('SIGN_UP_BUTTON_CLICKED');
            trackGetStartedClicked('Sign Up for Free');
            goToPartnerPage(signupUrl);
          }}
          className="w-52 rounded-lg border-2 border-[#318AE5] bg-[#318AE5] p-3 text-start font-medium text-white md:px-4"
        >
          <p className="text-xs text-white md:text-sm">
            {t('Teachers/Therapists')}
          </p>
          <div className="flex items-center gap-1">
            <p className="text-base text-white">{t('Sign Up for Free')}</p>
            <HiChevronRight size={20} color="white" />
          </div>
        </a>
        <Link
          href="/schedule-demo"
          onClick={() => {
            sendAnalyticsData('ADMINISTRATORS_SCHEDULE_DEMO_BUTTON_CLICKED');
            trackNavigation('schedule-demo', 'Schedule a Demo');
          }}
          className="w-52 cursor-pointer rounded-lg border-2 border-[#318AE5] bg-white p-3 text-start font-medium text-[#318AE5] md:px-4"
        >
          <p className="text-xs text-[#318AE5] md:text-sm">
            {t('Schools & Districts')}
          </p>
          <div className="flex items-center gap-1">
            <p className="text-base text-[#318AE5]">{t('Schedule a Demo')}</p>
            <HiChevronRight size={20} color="#318AE5" />
          </div>
        </Link>
      </div>
    </>
  );
};
